module.exports = __webpack_public_path__ + "img/company-aditif.965ec2c7.png";